import { useUpdateLoanWithProductMutation } from "../update-loan-with-product/updateLoanWithProductApiSlice";
import { usePushDataToEncompassMutation } from "../push-data-to-encompass/pushDataToEncompassApiSlice";
import { useCheckQueueStatusMutation } from "../check-queue-status/checkQueueStatusApiSlice";
import { registerObProgram } from "../../utils/aura-status-poll";

// Binds the existing OB register/push/queue mutations to registerObProgram so Qualify
// registers the selected program exactly like Add New Loan → Program & Pricing.
// Returns an async fn that resolves on success or throws AuraFlowError (errorKey).
export const useRegisterObProgram = () => {
	const [updateLoanWithProduct] = useUpdateLoanWithProductMutation();
	const [pushDataToEncompass] = usePushDataToEncompassMutation();
	const [checkQueueStatus] = useCheckQueueStatusMutation();

	return (args) =>
		registerObProgram({
			updateLoanWithProduct: (body) => updateLoanWithProduct(body).unwrap(),
			pushDataToEncompass: (body) => pushDataToEncompass(body).unwrap(),
			checkQueueStatus: (body) => checkQueueStatus(body).unwrap(),
			...args,
		});
};
